<template>
  <div class="mb-3">
    <CFormSelect
      :id="id"
      :model-value="currentValue"
      :options="normalizedOptions"
      :disabled="disabled"
      :invalid="!!invalidFeedback"
      :label="label"
      :size="['sm', 'lg'].includes(size) ? size : undefined"
      :class="addInputClasses"
      @update:model-value="handleChange"
    />
    <div
      v-if="invalidFeedback"
      class="invalid-feedback d-block"
    >
      {{ invalidFeedback }}
    </div>
  </div>
</template>

<script>
import { CFormSelect } from '@coreui/vue-pro'

export default {
  name: 'CSelect',
  components: { CFormSelect },
  props: {
    modelValue: { type: [String, Number, Array], default: '' },
    value: { type: [String, Number, Array], default: '' },
    options: { type: Array, default: () => [] },
    disabled: Boolean,
    label: { type: String, default: '' },
    id: { type: String, default: '' },
    size: { type: String, default: '' },
    addInputClasses: { type: [String, Object, Array], default: '' },
    invalidFeedback: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'update:value', 'change'],
  computed: {
    normalizedOptions() {
      return this.options.map(opt => {
        if (typeof opt === 'string') {
          return { label: opt, value: opt }
        }
        return { label: opt.label, value: opt.value, disabled: opt.disabled }
      })
    },
    currentValue() {
      return this.modelValue !== undefined && this.modelValue !== ''
        ? this.modelValue
        : this.value
    },
  },
  methods: {
    handleChange(val) {
      this.$emit('update:modelValue', val)
      this.$emit('update:value', val)
      this.$emit('change', val)
    },
  },
}
</script>
